<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <organization-group-list-filter
      @edit="editComponentFilters($event, 'filter__organization_groups__in')"
      @clean="cleanComponentFilters(['filter__organization_groups__in'])"
    />
  </div>
</template>

<script>
import CommonFiltersMixin from '../../../../common-filters/CommonFiltersMixin'

export default {
  name: 'OrganizationCommonFiltersMixin',
  mixins: [CommonFiltersMixin]
}
</script>
